import { render, staticRenderFns } from "./FeJohnLinares.vue?vue&type=template&id=1ca9c0d4&"
import script from "./FeJohnLinares.vue?vue&type=script&lang=js&"
export * from "./FeJohnLinares.vue?vue&type=script&lang=js&"
import style0 from "./FeJohnLinares.vue?vue&type=style&index=0&id=1ca9c0d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports